export default {
  coins: () => import("/build/layouts/coins.vue"),
  default: () => import("/build/layouts/default.vue"),
  desktop: () => import("/build/layouts/desktop.vue"),
  hotel: () => import("/build/layouts/hotel.vue"),
  mobile: () => import("/build/layouts/mobile.vue")
}